import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { PostAcqUWContent, PostAcqUWProforma } from 'components/underwrite/postAcquisition/postAcqUnderwrite';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import {
  setPostAcqProformaWidth, togglePostAcqProformaIsOpen, fetchPostAcqTaskData, appNotify, setPostAcqUWClientTask, setPostAcqValuationIsDirty
} from 'store/actions';
import { Resizable } from 're-resizable';
import { LoadingOverlayWrapper } from 'components/layout';
import { Constants } from 'utilities/constants';
import debounce from 'lodash/debounce';

const PostAcqUW = ({ classes, location, postAcqProformaIsOpen, proformaWidth, setPostAcqProformaWidth, togglePostAcqProformaIsOpen,
  isFetchingPostAcqUWData, selectedOpportunity, fetchPostAcqTaskData, selectedContainer, history, postAcqWorkflowGridDataUpdate,
  appNotify, setPostAcqUWClientTask, setPostAcqValuationIsDirty
}) => {
  useEffect(() => {
    document.addEventListener('keydown', shortCutToggleProforma);
    return () => {
      document.removeEventListener('keydown', shortCutToggleProforma);
    }
  }, []);

  // Leaving the underwrite page discards any uncommitted valuation edits (the
  // user has already saved or discarded via the SaveUWDialog / NavigationLock
  // prompt). Clear the dirty flag on unmount so it doesn't linger in redux and
  // spuriously trigger the SaveUWDialog when navigating away from other pages
  // (e.g. the post-acq workflow grid). Re-entering the page re-fetches fresh data.
  useEffect(() => {
    return () => {
      setPostAcqValuationIsDirty(false);
    }
  }, []);

  useEffect(() => {
    let abortController = new AbortController();
    const taskId = location.pathname.split(Constants.Routes.POSTACQ_TASK + '/')[1];
    fetchPostAcqTaskData(parseInt(taskId), null, history);
    return () => {
      abortController.abort();
    }
  }, [location]);

  useEffect(() => {
    if(postAcqWorkflowGridDataUpdate?.data) {
      const isOppDeleted = Object.entries(postAcqWorkflowGridDataUpdate.data).some(pair => parseInt(pair[0]) === selectedOpportunity?.id && pair[1].type === 'remove');
      if(isOppDeleted) {
        setPostAcqUWClientTask(null);
        appNotify(`Task ${selectedOpportunity?.id} has been deleted`, 'error')
        history.push(Constants.Routes.POSTACQ_WORKFLOW);
      }
    }
  }, [postAcqWorkflowGridDataUpdate])

  const onResize = debounce(() => {
    setPostAcqProformaWidth(proformaResizable.resizable.clientWidth);
  }, 100);
  const shortCutToggleProforma = (args) => { // Short cut open proforma using [ctrl alt A]
    if (args.code === 'KeyA' && args.altKey && args.ctrlKey) {
      togglePostAcqProformaIsOpen();
    }
  }

  let proformaResizable;  // Ref to resizable component, used to manually update size
  return (
    <LoadingOverlayWrapper
      className={classes.loadingOverlay}
      active={selectedOpportunity?.isProcessing || isFetchingPostAcqUWData}
      message={selectedOpportunity?.isProcessing ? 'Processing  data...' : 'Fetching underwrite data...'}
    >
      {selectedOpportunity && selectedContainer
        ? <div className={classes.container}>
            <PostAcqUWContent />
            {postAcqProformaIsOpen
              ? <div>
                <Resizable ref={r => { proformaResizable = r; }} onResize={onResize} minWidth='300' maxWidth='400'
                  size={{ width: `${proformaWidth}px`, height: ('100%') }}
                  enable={{ top: false, right: false, bottom: false, left: true, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}>
                    <PostAcqUWProforma resizableWidth={proformaWidth} />
                </Resizable>
              </div>
              : null
            }
          </div>
        : null
      }
    </LoadingOverlayWrapper>
  )
};

const mapStateToProps = (state) => ({
  selectedOpportunity: state.postAcqUWState.postAcqUWClientTask,
  selectedContainer: state.postAcqUWState.selectedContainer,
  postAcqProformaIsOpen: state.postAcqUWState.postAcqProformaIsOpen,
  proformaWidth: state.postAcqUWState.proformaWidth,
  isFetchingPostAcqUWData: state.postAcqUWState.isFetchingPostAcqUWData,
  postAcqWorkflowGridDataUpdate: state.postAcqUWState.postAcqWorkflowGridDataUpdate,
});

const mapDispatchToProps = {
  setPostAcqProformaWidth,
  togglePostAcqProformaIsOpen,
  fetchPostAcqTaskData,
  appNotify,
  setPostAcqUWClientTask,
  setPostAcqValuationIsDirty
};

const styles = theme => ({
  container: {
    display: 'flex',
    gridTemplateAreas: `'content proforma'`,
    gridTemplateColumns: '1fr auto',
    height: '100%',
    width: '100%'
  },
  loadingOverlay: {
    display: 'flex',
    width: '100%'
  }
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PostAcqUW);